const errorCodes = {
    Already_In_Use: "Already in use",
    Invalid:"Invalid code"
}

export default function getErrorMessage(code) {
    return errorCodes[code]
}